module.exports = __webpack_public_path__ + "media/src/assets/images/about-bg-899c22e7803c1720144d6bff965f2369.jpg";